<template>
	<v-form ref="form">
		<v-row dense>
			<v-col cols="12">
				<v-combobox
					v-model="item.category"
					:items="categories"
					label="Категорія"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.category"
					:rules="[rules.required, rules.onlyFromList]"
					@change="onCategory"
					@focus="loadCategories"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.brand"
					:items="brands"
					label="Марка"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.brand"
					:rules="[rules.required, rules.onlyFromList]"
					@change="onBrand"
					@focus="loadBrands"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.model"
					:items="models"
					label="Модель"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.model"
					:rules="modelRules"
					@change="onModel"
					@focus="loadModels"
				>
					<template v-slot:append-outer v-if="visibleDeleteModel">
						<!-- <v-icon @click="onDeleteModel(item.model)">mdi-delete</v-icon> -->
						<v-menu offset-y>
							<template v-slot:activator="{ on, attrs }">
								<v-icon v-bind="attrs" v-on="on">mdi-dots-vertical</v-icon>
							</template>
							<v-list>
								<v-list-item @click="onDeleteModel(item.model)" :disabled="!item.model">
									<v-list-item-icon>
										<v-icon>mdi-delete</v-icon>
									</v-list-item-icon>
									<v-list-item-title>Видалити модель</v-list-item-title>
								</v-list-item>
								<v-list-item @click="onUpgrateModel" :disabled="item.category==null || item.brand==null">
									<v-list-item-icon>
										<v-icon>mdi-autorenew</v-icon>
									</v-list-item-icon>
									<v-list-item-title>Актуалізувати довідник</v-list-item-title>
								</v-list-item>
							</v-list>
						</v-menu>
					</template>
				</v-combobox>
			</v-col>
		
			<!-- Рік випуску авто -->
			<v-col cols="12" v-if="yearProdPeriod">
				<v-system-bar>
					<span>Рік випуску авто</span>
					<v-spacer></v-spacer>
				</v-system-bar>
			</v-col>
			<v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" v-if="yearProdPeriod">
				<v-text-field
					v-model="item.yearProdFrom"
					label="Від"
					outlined
					dense
					type="number"
					hide-details="auto"
					:min="minYear"
					:max="maxYear"
				></v-text-field>
			</v-col>
			<v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" v-if="yearProdPeriod">
				<v-text-field
					v-model="item.yearProdTo"
					label="До"
					outlined
					dense
					type="number"
					hide-details="auto"
					:min="minYear"
					:max="maxYear"
				></v-text-field>
			</v-col>
			<v-col cols="12" v-if="!yearProdPeriod">
				<v-combobox
					v-model="item.yearProd"
					:items="years"
					label="Рік випуску авто"
					outlined
					dense
					hide-details="auto"
					:loading="loading.yearProd"
					:rules="[rules.required]"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.driver"
					:items="drivers"
					label="Тип приводу"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.driver"
					@focus="loadDrivers"
				></v-combobox>
			</v-col>

			<!-- Об'єм двигуна -->
			<!-- <v-col cols="12">
				<v-system-bar>
					<span>Об'єм двигуна, л.</span>
					<v-spacer></v-spacer>
				</v-system-bar>
			</v-col>
			<v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
				<v-text-field
					v-model="item.engineVolumeFrom"
					label="Від"
					outlined
					dense
					type="number"
					hide-details="auto"
					:min="minEngineVolume"
					:max="maxEngineVolume"
				></v-text-field>
			</v-col>
			<v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
				<v-text-field
					v-model="item.engineVolumeTo"
					label="До"
					outlined
					dense
					type="number"
					hide-details="auto"
					:min="minEngineVolume"
					:max="maxEngineVolume"
				></v-text-field>
			</v-col> -->
			<v-col cols="12">
				<v-combobox
					v-model="item.fuel"
					:items="fuels"
					label="Тип палива"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.fuel"
					@focus="loadFuels"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.gearbox"
					:items="gearboxes"
					label="Коробка передач"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.gearbox"
					@focus="loadGearboxes"
				></v-combobox>
			</v-col>
			<!-- <v-col cols="12">
				<v-combobox
					v-model="item.options"
					:items="options"
					label="Опції"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					multiple
					@focus="loadOptions"
				></v-combobox>
			</v-col> -->
			<v-col cols="12">
				<v-combobox
					v-model="item.color"
					:items="colors"
					label="Колір"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.color"
					@focus="loadColors"
				></v-combobox>
			</v-col>
			<!-- <v-col cols="12">
				<v-combobox
					v-model="item.country"
					:items="countries"
					label="Країна виробник"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.country"
					@focus="loadCountries"
				></v-combobox>
			</v-col> -->
			<v-col cols="12">
				<v-combobox
					v-model="item.state"
					:items="states"
					label="Область"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.state"
					@change="onState"
					@focus="loadStates"
				></v-combobox>
			</v-col>
			<v-col cols="12">
				<v-combobox
					v-model="item.city"
					:items="cities"
					label="Місто"
					outlined
					dense
					item-text="name"
					item-value="id"
					hide-details="auto"
					:loading="loading.city"
					@focus="loadCities"
				></v-combobox>
			</v-col>
		</v-row>
	</v-form>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import mixin from './mixin/parameters'

export default {
	name: 'vehicle.parameters.showroom',
	mixins: [mixin],

	data () {
		return {
			minYear: (new Date()).getFullYear()-1,
			maxYear: (new Date()).getFullYear(),
			minEngineVolume: 0,
			maxEngineVolume: 10,

			loading: {
				category: false,
				brand: false,
				model: false,
				generation: false,
				modification: false,
				yearProd: false,
				driver: false,
				option: false,
				fuel: false,
				gearbox: false,
				color: false,
				country: false,
				state: false,
				city: false,
			},
		}
	},
	props: {
		module:			{ type: String, default: 'VehicleEstimate'}, // check | market | metodica | exploration | averageprice
		yearProdPeriod:	{ type: Boolean, default: false},
	},

	computed: {
		...mapGetters([
			'roles',
			'categories', 'fuels', 'colors', 'countries', 'states'
		]),

		
		...mapGetters('VehicleEstimate',[
			'brands', 'models',
			'generations', 'modifications', 'bodystyles', 'drivers', 'gearboxes', 'options', 'cities'
		]),

		/* ...mapGetters('VehicleCategory', { categories: 'items' }),
		...mapGetters('VehicleBrand', { brands: 'items' }),
		...mapGetters('VehicleBrandModel', { models: 'items' }),
		...mapGetters('VehicleBrandModelYear', { years: 'items' }), 
		
		...mapGetters('VehicleBodystyle', { bodystyles: 'items' }), 
		...mapGetters('VehicleColor', { colors: 'items' }), 
		...mapGetters('VehicleCountry', { countries: 'items' }), 
		...mapGetters('VehicleDriver', { drivers: 'items' }), 
		...mapGetters('VehicleFuel', { fuels: 'items' }), 
		...mapGetters('VehicleGearbox', { gearboxs: 'items' }), 
		...mapGetters('VehicleGeneration', { generations: 'items' }), 
		...mapGetters('VehicleModification', { modifications: 'items' }), 
		...mapGetters('VehicleOption', { options: 'items' }), 
		*/

		...mapGetters('app', ['profile']),

		years() {
			const arrayRange = (start, stop, step) =>
			Array.from(
				{ length: (stop - start) / step + 1 },
				(value, index) => start + index * step
			);

			return arrayRange(this.minYear, this.maxYear, 1).reverse();
		},

		visibleDeleteModel() {
			return this.roles.includes('ADMIN')
		},
		
		modelRules() {
			return this.roles.includes('ADMIN') ? [] : [this.rules.required, this.rules.onlyFromList]
		},
	},

	created () {
		this.loadCategories().finally(() => {
			if(this.categories.length) {
				this.$set(this.item, 'category', this.categories[0])
			}
		});
	},
	methods: {
		...mapActions([
			'setCategories', 'setFuels', 'setColors', 'setCountries', 'setStates'
		]),

		...mapActions('VehicleEstimate', [
			'setBrands', 'setModels', 'setGenerations', 'setModifications', 'setBodystyles', 'setDrivers',
			'setGearboxes','setOptions','setCities',
		]),

		clearBrand () {
			this.$set(this.item, 'brand', null)
			this.setBrands()

			this.clearModel()
		},

		clearModel () {
			this.$set(this.item, 'model', null)
			this.setModels()
			
			this.clearGeneration()
		},

		clearGeneration () {
			this.$set(this.item, 'generation', null)
			this.setGenerations()
			
			this.clearModification()
		},

		clearYearProd() {
			this.$set(this.item, 'yearProd', null)
			this.minYear = 1900
			this.maxYear = (new Date()).getFullYear()
		},

		clearModification () {
			this.$set(this.item, 'modification', null)
			this.setModifications()
		},

		clearBodystyle () {
			this.$set(this.item, 'bodystyle', null)
			this.setBodystyles()
		},

		clearDriver () {
			this.$set(this.item, 'driver', null)
			this.setDrivers()
		},

		clearGearbox () {
			this.$set(this.item, 'gearbox', null)
			this.setGearboxes()
		},

		clearOption () {
			this.$set(this.item, 'option', null)
			this.setOptions()
		},

		clearCity () {
			this.$set(this.item, 'city', null)
			this.setCities()
		},

		// Завантаження категорій
		loadCategories(e) {
			//console.log(this.$options.name, 'loadCategories','this.categories.length', this.categories.length)

			if(this.categories.length) {
				return new Promise(resolve => true)
			} else {
				this.loading.category = true
				var that = this
				return axios.get('/vehicle/category').then(response => {
					that.setCategories(response.data.filter((element) => ['CAR','TRUCK'].includes(element.code)))
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.category = false));
			}
		},

		// Завантаження брендів
		loadBrands() {
			if(this.item?.category?.id && this.brands.length == 0) {
				this.loading.brand = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/brand`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setBrands(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.brand = false));
			}
		},

		// Завантаження моделей
		loadModels() {
			if(this.item?.category?.id && this.item?.brand?.id && this.models.length == 0) {
				this.loading.model = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/brand/${this.item.brand.id}/models`).then(response => {
					//console.log(that.$options.name, 'GetdModels','response.data', response.data)
					that.setModels(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.model = false));
			}
		},

		// Завантаження поколінь
		loadGenerations() {
			if(this.item?.model?.id && this.generations.length == 0) {
				this.loading.generation = true
				var that = this
				axios.get(`/vehicle/model/${this.item.model.id}/generation`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setGenerations(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.generation = false));
			}
		},

		// Завантаження років виробництва
		loadYearProds() {
			//console.log(this.$options.name, 'loadYearProds','generation', this.item.generation)

			this.minYear = this.item?.generation?.yearFrom ? this.item.generation.yearFrom : 1900
			this.maxYear = this.item?.generation?.yearTo ? this.item.generation.yearTo : (new Date()).getFullYear()
		},

		// Завантаження модифікацій
		loadModifications() {
			if(this.item?.generation?.id && this.modifications.length == 0) {
				this.loading.modification = true
				var that = this
				axios.get(`/vehicle/generation/${this.item.generation.id}/modification`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setModifications(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.modification = false));
			}
		},

		// Завантаження типів кузова
		loadBodystyles() {
			if(this.item?.category?.id && this.bodystyles.length == 0) {
				this.loading.bodystyle = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/bodystyle`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setBodystyles(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.bodystyle = false));
			}
		},

		// Завантаження типів приводу
		loadDrivers() {
			if(this.item?.category?.id && this.drivers.length == 0) {
				this.loading.driver = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/driver`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setDrivers(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.driver = false));
			}
		},

		// Завантаження типів коробок передач
		loadGearboxes() {
			if(this.item?.category?.id && this.gearboxes.length == 0) {
				this.loading.gearbox = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/gearbox`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setGearboxes(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.gearbox = false));
			}
		},

		// Завантаження опцій
		loadOptions() {
			if(this.item?.category?.id && this.options.length == 0) {
				this.loading.option = true
				var that = this
				axios.get(`/vehicle/category/${this.item.category.id}/option`).then(response => {
					//console.log(that.$options.name, 'GetBrands','response.data', response.data)
					that.setOptions(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.option = false));
			}
		},

		// Завантаження типів палива
		loadFuels() {
			if(this.fuels.length == 0) {
				this.loading.fuel = true
				var that = this
				axios.get('/vehicle/fuel').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setFuels(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.fuel = false));
			}
		},

		// Завантаження кольорів
		loadColors() {
			if(this.colors.length == 0) {
				this.loading.color = true
				var that = this
				axios.get('/vehicle/color').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setColors(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.color = false));
			}
		},

		// Завантаження країн виробників
		loadCountries() {
			if(this.countries.length == 0) {
				this.loading.country = true
				var that = this
				axios.get('/vehicle/country').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setCountries(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.country = false));
			}
		},

		// Завантаження областей
		loadStates() {
			if(this.states.length == 0) {
				this.loading.state = true
				var that = this
				axios.get('/state').then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setStates(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.state = false));
			}
		},

		// Завантаження міст
		loadCities() {
			if(this.item?.state?.id && this.cities.length == 0) {
				this.loading.city = true
				var that = this
				axios.get(`/state/${this.item.state.id}/city`).then(response => {
					//console.log(that.$options.name, 'created','response.data', response.data)
					that.setCities(response.data)
				}, error => {
					console.log('error', error)
				}).finally(() => (this.loading.city = false));
			}
		},

		onCategory (item) {
			this.clearBrand()
			this.clearBodystyle()
			this.clearDriver()
			this.clearGearbox()
			this.clearOption()
		},

		onBrand (item) {
			this.clearModel()
		},

		onModel (item) {
			this.clearGeneration()
		},

		onGeneration (item) {
			this.clearYearProd()
			this.clearModification()
		},

		onState (item) {
			this.clearCity()
		},

		onDeleteModel (item) {
			//console.log(that.$options.name, 'onDeleteModel', 'item', item)
			//console.log(that.$options.name, 'onDeleteModel', 'profile', this.profile)

			if(item?.id) {
				var that = this
				axios.put(`/vehicle/models/${item.id}/datedelete`).then(response => {
					//console.log(that.$options.name, 'onDelete','response.data', response.data)
					const index = that.models.indexOf(item)
					that.models.splice(index, 1);
					that.item.model = null
				}, error => {
					console.log('error', error)
				});
			}
		},

		onUpgrateModel() {
			if(this.item?.category?.id && this.item?.brand?.id) {
				//console.log(this.$options.name, 'onUpgrateModel', 'category', this.item.category.id, 'brand', this.item.brand.id)

				var that = this
				axios.post(`/vehicle/category/${this.item.category.id}/brand/${this.item.brand.id}/models/upgrate`).then(response => {
					//console.log(that.$options.name, 'onUpgrateModel','response.data', response.data)
					that.setModels(response.data)
				}, error => {
					console.log('error', error)
				});
			}
		},
	},
}
</script>